// extracted by mini-css-extract-plugin
module.exports = {"layout":"Main_layout__3RodA"};